import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const terminateImpersonateSession = (userId, callback, errCallback) => {
  return async (dispatch) => {
    dispatch({ type: 'TERMINATE_IMPERSONATE_SESSION' });
    let unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const token = await user.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.delete(
            `/ads/users/${userId}/terminate-impersonate-session`,
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
              },
            },
          );
          if (response.status === 200) {
            dispatch({ type: 'TERMINATE_IMPERSONATE_SESSION_DONE' });
            if (typeof callback === 'function') callback(response.data);
          } else {
            dispatch({
              type: 'TERMINATE_IMPERSONATE_SESSION_FAILED',
              payload: response?.data,
            });
            if (typeof errCallback === 'function') errCallback();
          }
        } catch (e) {
          console.log(e);
          dispatch({
            type: 'TERMINATE_IMPERSONATE_SESSION_FAILED',
            payload: e?.message,
          });
          if (typeof errCallback === 'function') errCallback();
        }
      } else {
        dispatch({
          type: 'TERMINATE_IMPERSONATE_SESSION_FAILED',
          payload: 'User not authenticated',
        });
        if (typeof errCallback === 'function') errCallback();
      }
      unsubscribe();
    });
  };
};

export default terminateImpersonateSession;
